// extracted by mini-css-extract-plugin
module.exports = {"collapsible":"Collapsible_collapsible__vEP2G","wrapper":"Collapsible_wrapper__VpR_d"};